import { render, staticRenderFns } from "./DocumentAddress.vue?vue&type=template&id=4cdfd273&scoped=true"
import script from "./DocumentAddress.vue?vue&type=script&lang=js"
export * from "./DocumentAddress.vue?vue&type=script&lang=js"
import style0 from "./DocumentAddress.vue?vue&type=style&index=0&id=4cdfd273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfd273",
  null
  
)

export default component.exports